<template>
    <div ref="player" class="video-container">
        <div
            v-if="videoSource === 'youtube'"
            ref="yplayer"
        />
        <iframe
            v-if="videoSource === 'vimeo'"
            :src="'https://player.vimeo.com/video/' + videoId + '?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media'"
            allowfullscreen
            allowtransparency
            allow="autoplay"
            ref="vplayer"
            :title="videoTitle"
        />
        
        <iframe
            v-if="videoSource === 'warpwire'"
            :src="'https://udayton.warpwire.com/w/' + videoId"
            allow="autoplay; encrypted-media; fullscreen; picture-in-picture;"
            :id="'ww_' + videoId"
            :data-ww-id="'ww_' + videoId"
            allowfullscreen
            :title="videoTitle"
        />

        <div 
            v-if="videoSource === 'campusreel'"
            :id="'campusreel_' + videoId"
        >Loading the player...</div>

    </div>
</template>

<script>
import YTPlayer from 'yt-player';
import VPlayer from '@vimeo/player';

export default {
    name: 'VideoPlayer',
    props: {
        videoId: {
            type: String,
            required: true,
        },
        videoSource: {
            type: String,
            required: true,
        },
        videoTitle: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            player: undefined,
        };
    },
    mounted() {

        if(this.videoSource == 'youtube'){
            this.player = new YTPlayer(this.$refs.yplayer );
            this.player.load(this.videoId);

        }

        if(this.videoSource == 'vimeo'){
            this.player = new VPlayer(this.$refs.vplayer)
        }

        if(this.videoSource == 'warpwire'){
            if(!(typeof wwIframeApi === 'function')){

                var tag = document.createElement('script');
                //tag.src = "https://www.warpwire.com/player_api/"
                //ww documentation says to use the above url, but it redirects and adds the script below
                tag.src = "https://static-cdn.warpwire.com/player_api/wwIframeApi.min.js";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
               
                tag.addEventListener("load", this.warpWireReady);
                
            } else {
                this.warpWireReady;
            }
            
        }

        if(this.videoSource == 'campusreel'){
            if(!(typeof jwplayer === 'function')){

                var tag = document.createElement('script');
                tag.src = "https://cdn.jwplayer.com/libraries/psJn6cro.js";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
               
                tag.addEventListener("load", this.jwPlayerReady);
                
            } else {
                this.jwPlayerReady;
            }
            
        }

        this.$parent.$on('changedSlide', this.slideChangeIntercept);
        
    },
    methods: {
        warpWireReady() {
            var wwPlayerApi = new wwIframeApi();
            this.player = wwPlayerApi('ww_' + this.videoId);
        },
        jwPlayerReady() {
           this.player = jwplayer('campusreel_' + this.videoId).setup({ 
                "playlist": "//cdn.jwplayer.com/v2/media/" + this.videoId
            });
        },
        slideChangeIntercept() {
            if(this.videoSource == 'warpwire'){
                document.getElementById('ww_' + this.videoId).src += '';
            }

            if(this.player !== undefined){
                this.player.pause();        
            }
            
        },
    },
};
</script>


<style lang="scss">
.landing-hero__video-column > .video-container {
    @include breakpoint(medium) {
        min-height: 440px;
    }
}

.media-callout__media, .main-tab__media > .video-container {
      @include breakpoint(medium) {
        max-height: 385px;
    }
}

.video-container {
    width: 100%;
    position: relative;
    height: 100%;
    margin: 15px 0;
    min-height: 40vw;

    @include breakpoint(medium) {
        min-height: 385px;
    }
}

.video-container > iframe {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
    min-height: 40vw;

    @include breakpoint(medium) {
        min-height: 385px;
    }
}

.column__container .video-container {
    @include breakpoint(medium){
        min-height: 35vw;
    }

    @include breakpoint(large) {
        min-height: 385px;
    }
}

.column__container .video-container > iframe {
    @include breakpoint(medium){
        min-height: 35vw;
    }

    @include breakpoint(large) {
        min-height: 385px;
    }
}

.campaign-hero-feature-video__video-wrapper {
    .video-container {
        margin: 0;
        aspect-ratio: 16 / 9;
        @supports not (aspect-ratio: 16/9) {
            padding-bottom: 56.25% // 16/9 aspect ratio

        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/VideoPlayer.vue